import React from 'react';
import { ToolbarButton } from '@mui/x-data-grid-pro';
import Tooltip from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';
import DownloadIcon from '@mui/icons-material/Download';

const BulkDownloadButton = ({ onClick, loading, disabled, label }) => (
    <Tooltip title={label || 'Bulk Download'}>
        <ToolbarButton onClick={onClick} disabled={disabled || loading}>
            {loading ? <CircularProgress size={16} /> : <DownloadIcon fontSize="small" />}
        </ToolbarButton>
    </Tooltip>
);

export default BulkDownloadButton;